






// src/pages/Workers/Workers/FilterDrawer.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Drawer,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import profilecross from "../../../../assets/profilecross.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";
import CustomButton from "../../../../components/CustomButton";
import save from "../../../../assets/save.svg";
 import WorkersMultiSelectDropdown from "../../../../components/workersMultiSelection";
import { BASE_URL } from "../../../../components/BaseUrl";
import { decryptToken } from "../../../../Utlis/Encryption";
import { useSelector } from "react-redux";
import Slider from "@mui/material/Slider";

// ---------------- STATUS OPTIONS ----------------
const statusOptions = [
  { key: "all", value: "all" },
  { key: "invited", value: "invited" },
  { key: "pending", value: "pending" },
  { key: "active", value: "active" },
  { key: "inactive", value: "inactive" },
  { key: "rejected", value: "rejected" },
];

const FilterDrawer = ({ open, onClose, filters, onApplyFilters }) => {
  const { t } = useTranslation();
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [localFilters, setLocalFilters] = useState(filters);
const { company } = useSelector((state) => state.auth);
const companyId = company?.id;
console.log(companyId)
  const [departments, setDepartments] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [salaryActive, setSalaryActive] = useState(false);
const [hoursActive, setHoursActive] = useState(false);
useEffect(() => {
  if (open) {
    setSalaryActive(Boolean(filters.salary));
    setHoursActive(Boolean(filters.work_hours));
  }
}, [open]);
  // ---------------- FETCH DEPARTMENTS ----------------
const fetchDepartments = async () => {
  try {
    const res = await fetch(
      `${BASE_URL}/departments?no_pagination=true`,
      {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      }
    );

    const data = await res.json();
    console.log("departments data", data);

    const list = data?.data?.departments || [];

    setDepartments(
      list.map((d) => ({
        label: d.name,   // shown in dropdown
        value: d.id,     // sent in filter
      }))
    );
  } catch (e) {
    console.error("Department fetch error", e);
  }
};


  // ---------------- FETCH WORKERS ----------------
  const fetchWorkers = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}/public/workers?no_pagination=true&company_id=${companyId}&status=active`,
        { headers: { Authorization: `Bearer ${decryptedToken}` } }
      );
      const data = await res.json();

      setWorkers(
        (data?.data?.records || []).map((w) => ({
          label: `${w.first_name} ${w.last_name}`,
          value: w.id,
          email: w.email,
          fullLabel: `${w.first_name} ${w.last_name}\n${w.email}`,
        }))
      );
    } catch (e) {
      console.error("Workers fetch error", e);
    }
  };

  useEffect(() => {
    if (open) {
      setLocalFilters(filters);
      fetchDepartments();
      fetchWorkers();
    }
  }, [open]);

  // ---------------- APPLY ----------------
  const apply = () => {
      console.log("🔎 Applied Worker Filters:", localFilters);

    onApplyFilters(localFilters);
    onClose();
  };

const clear = () => {
  setSalaryFrom("");
  setSalaryTo("");
  setWorkHours(0);

  const cleared = {
    status: "",
    department_id: [],
    worker_ids: [],
    salary: "",
    shift: "",
    work_hours: "",
  };

  setLocalFilters(cleared);
  onApplyFilters(cleared);
  onClose();
};

const HOURS_MIN = 0;
const HOURS_MAX = 24;

const [workHours, setWorkHours] = useState(0);

const [salaryFrom, setSalaryFrom] = useState("");
const [salaryTo, setSalaryTo] = useState("");

useEffect(() => {
  if (open) {
    // salary
    if (filters.salary) {
      const [from, to] = filters.salary.split("-");
      setSalaryFrom(from || "");
      setSalaryTo(to || "");
    } else {
      setSalaryFrom("");
      setSalaryTo("");
    }

    // work hours
    if (filters.work_hours) {
      const [, max] = filters.work_hours.split("-").map(Number);
      setWorkHours(max);
    } else {
      setWorkHours(0); // ✅ default
    }
  }
}, [open]);


const sliderSx = (active) => ({
  height: 6,

  "& .MuiSlider-rail": {
    backgroundColor: "#E0E0E0",
    opacity: 1,
  },

  "& .MuiSlider-track": {
    backgroundColor: active ? "#8E24AA" : "#E0E0E0",
  },

  "& .MuiSlider-thumb": {
    width: 16,
    height: 16,
    backgroundColor: active ? "#8E24AA" : "#BDBDBD",
    border: "2px solid white",
    boxShadow: active
      ? "0 0 0 2px rgba(142,36,170,0.25)"
      : "none",
  },

  "& .MuiSlider-markLabel": {
    fontSize: 12,
    color: "#777",
    mt: 1,
  },
});


  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: { width: { xs: "100%", sm: 420, md: 560 }, backgroundColor: "#E7EBEE" },
      }}
    >
      {/* HEADER */}
      <Box sx={{ px: 2, py: 1.5, display: "flex", alignItems: "center", gap: 1 }}>
        <IconButton onClick={onClose}>
          <img src={profilecross} alt="close" />
        </IconButton>
            <CustomText sx={{ ...textStyles.h1, fontSize: 20, fontWeight: 600, color: "#2C384C" }}>
          {t("filterDrawer.titleWorkers")}
        </CustomText>
      </Box>

      <Box sx={{ px: 2 }}>
        <Box sx={{ backgroundColor: "#fff", px: 3, py: 3 }}>

        
          <CustomText
            sx={{
              ...textStyles.h1,
              fontSize: 18,
              fontWeight: 500,
              color: "#2C384C",
              textAlign: "left",
              pt: 3,
            }}
          >
            {t("filterDrawer.status")}
          </CustomText>

          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 2 }}>
            {statusOptions.map((opt) => {
              const isSelected = localFilters.status === opt.value;
              return (
                <Button
                  key={opt.key}
                  variant="outlined"
                  size="small"
                  onClick={() =>
                    setLocalFilters((prev) => ({
                      ...prev,
                      status: isSelected ? "" : opt.value,
                    }))
                  }
                  sx={{
                    borderRadius: "6px",
                    fontSize: "15px",
                    fontFamily: "Poppins, sans-serif",
                    textTransform: "none",
                    py: 0.8,
                    px: 2,
                    color: isSelected ? "#006EC2" : "#363333",
                    border: isSelected ? "2px solid #006EC2" : "2px solid #091E4224",
                    backgroundColor: "transparent",
                  }}
                >
             {t(`statuses.${opt.key}`)}
                </Button>
              );
            })}
          </Box>

          {/* DEPARTMENT */}
          <Box mt={3}>
            <WorkersMultiSelectDropdown
              label={t("filterDrawer.department")}
              values={localFilters.department_id || []}
              options={departments}
              enableSearch
              onChange={(e) =>
                setLocalFilters((p) => ({
                  ...p,
                  department_id: e.target.value,
                }))
              }
            />
          </Box>

          {/* WORKERS */}
          <Box mt={1.5}>
            <WorkersMultiSelectDropdown
              label={t("employee")}
              values={localFilters.worker_ids || []}
              options={workers}
              enableSearch
              onChange={(e) =>
                setLocalFilters((p) => ({
                  ...p,
                  worker_ids: e.target.value,
                }))
              }
              renderValue={(selected) =>
                selected
                  .map((id) => workers.find((w) => w.value === id)?.label)
                  .join(", ")
              }
              renderOption={(props, option) => (
                <li {...props}>
                  <span>{option.label}</span>
                  <span style={{ fontSize: 12, color: "#888" }}>
                    {option.email}
                  </span>
                </li>
              )}
            />
          </Box>

 
<Box mt={1.5} sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
  <label className="field_label">
    {t("filterDrawer.shift")}
  </label>
  <select
    className="project_input"
          style={{height:"40px"}}
    value={localFilters.shift || ""}
    onChange={(e) =>
      setLocalFilters((p) => ({ ...p, shift: e.target.value }))
    }
  >
    <option value="">{t("filterDrawer.selectShift")}</option>
   <option value="morning">{t("filterDrawer.shifts.morning")}</option>
<option value="evening">{t("filterDrawer.shifts.evening")}</option>
<option value="night">{t("filterDrawer.shifts.night")}</option>
{/* <option value="rotational">{t("filterDrawer.shifts.rotational")}</option> */}
  </select>
</Box>





<Box mt={2} >
  <label className="field_label">{t("range")}</label>

  <Box sx={{ display: "flex", gap: 2 }}>
    <Box sx={{ flex: 1 , flex: 1,display:"flex",flexDirection:"column" }}>
      <label className="field_label">{t("from")}</label>
      <input
        type="number"
        min={0}
        className="project_input"
        style={{height:"40px"}}
        value={salaryFrom}
        onChange={(e) => {
          const val = e.target.value;
          setSalaryFrom(val);

          setLocalFilters((p) => ({
            ...p,
            salary: val || salaryTo ? `${val || 0}-${salaryTo || ""}` : "",
          }));
        }}
      />
    </Box>

    <Box sx={{ flex: 1,display:"flex",flexDirection:"column" }}>
      <label className="field_label">{t("to")}</label>
      <input
        type="number"
        className="project_input"
           style={{height:"40px"}}
        value={salaryTo}
        onChange={(e) => {
          const val = e.target.value;
          setSalaryTo(val);

          setLocalFilters((p) => ({
            ...p,
            salary: salaryFrom || val ? `${salaryFrom || 0}-${val}` : "",
          }));
        }}
      />
    </Box>
  </Box>
</Box>

<Box mt={2}>
  <label className="field_label">{t("workHours")}</label>

  <Slider
    value={workHours}
    min={HOURS_MIN}
    max={HOURS_MAX}
    step={1}
    marks={[
      { value: 0, label: "0 min" },
      { value: 24, label: "24 max" },
    ]}
    valueLabelDisplay="on"
    sx={{
      height: 6,

      "& .MuiSlider-rail": {
        backgroundColor: "#E0E0E0",
        opacity: 1,
      },

      "& .MuiSlider-track": {
        backgroundColor: "#8E24AA", // purple till selected
      },

      "& .MuiSlider-thumb": {
        backgroundColor: "#8E24AA",
        border: "2px solid white",
      },
    }}
    onChange={(e, value) => {
      setWorkHours(value);

      setLocalFilters((p) => ({
        ...p,
        work_hours: value === 0 ? "" : `0-${value}`,
      }));
    }}
  />
</Box>
          {/* BUTTONS */}
          <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
            <CustomButton
              onClick={apply}
              label={
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img src={save} alt="save" width={16} />
                  {t("filterDrawer.apply")}
                </Box>
              }
            />
            <Button
              variant="outlined"
              onClick={clear}
              sx={{ border: "2px solid #006EC2", color: "#006EC2" }}
            >
              {t("filterDrawer.clear")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default FilterDrawer;
